// extracted by mini-css-extract-plugin
module.exports = {"Container":"NotesList_Container__3meJr","HeaderContainer":"NotesList_HeaderContainer__3K6TG","List":"NotesList_List__2-NvA"};